import useThemes from 'hooks/useThemes';
import { useEffect, useState } from 'react';
import { useAppSelector, useAppTranslation, useErrTranslation } from 'app/hooks';
import { platformStates } from 'redux/platformSlice';
import Typo from 'consts/typography';
import { uniqueId } from 'utils/commonUtils';
import TbetBuySellModal from './Modals/TbetBuySellModal';
import BuyModal from './Modals/BuyModal';
import UniSwap from './Modals/UniSwap';
import PancakeSwap from './Modals/PancakeSwap';
import { useHandleGetWallets } from 'hooks/useHandleGetWallets';

interface SwapTokenProps {}

const tabButtons = [
  // {
  //   value: 1,
  //   label: 'UniSwap',
  //   grow: 5,
  // },
  // {
  //   value: 2,
  //   label: 'Pancake',
  //   grow: 5,
  // },
  {
    value: 3,
    label: 'cashier.crypto',
    grow: 5,
  },
  // {
  //   value: 4,
  //   label: 'USD→$TBET',
  //   grow: 5,
  // },
];

const SwapToken: React.FunctionComponent<SwapTokenProps> = () => {
  const { isPhone, isTablet } = useAppSelector(platformStates);
  const t = useAppTranslation();
  const [activeTab, setActiveTab] = useState<number>(3);

  const onChangeActiveTab = (value: number) => {
    setActiveTab(value);
  };

  return (
    <div className="flex justify-center">
      <div className="cashier-swap">
        {activeTab === 1 && <UniSwap />}
        {activeTab === 2 && <PancakeSwap />}
        {activeTab === 3 && <BuyModal />}
        {activeTab === 4 && <TbetBuySellModal />}
      </div>
    </div>
  );
};

export default SwapToken;
